import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { resetPasswordByForgotPasswordKey, updateLoginState, resetLoginState } from '../actions/loginactions'
import * as appUtilityFunctions from '../../../infrastructure/apputilityfunctions';

export default function ResetForgotPassword() {
  const { register, handleSubmit, reset: resetLoginstate, watch, formState: { errors } } = useForm();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const state = useSelector(state => state.loginReducer);
  let passwordResetKey = appUtilityFunctions.getUrlParameter('resetKey');

  if (passwordResetKey == null || passwordResetKey == '') {
 //   return <h3>Reset Key not found. Please Check Email & Try Again.</h3>;
  }
  const onSubmit =async () => {
    var resp=await dispatch(resetPasswordByForgotPasswordKey(passwordResetKey));
    if(resp!=null){
      alert(resp);
      return;
    }
    resetLoginstate();
    dispatch(resetLoginState());
    navigate('/resetforgotpasswordsuccess');
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateLoginState({ name, value }));
  }
  return (
    <div className="auth-fluid">
      <div className="auth-fluid-form-box">
        <div className="align-items-center d-flex h-100">
          <div className="card-body">
            <div className="auth-brand text-center text-lg-start">
              <a href="index.html" classNameName="logo-dark">
                <span><img src="content/theme/assets/images/asniclogo.png" alt="" style={{ "height": 50 }} /></span>
              </a>
            </div>
            <h4 className="mt-0">Reset Forgot Password</h4>
            <p className="text-muted mb-4">Enter New Passsword.</p>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-3">
                <label for="newUserPassword" className="form-label">New Password</label>
                <input className="form-control" type="password" id="newUserPassword"
                  placeholder="Enter new Password"
                  name='newUserPassword'
                  value={state.newUserPassword}
                  {...register("newUserPassword", { required: true, minLength: 12, onChange: (e) => handleInputChange(e) })} />
                {errors.newUserPassword && <span style={{ color: "red" }}> Minimum 12 Characters Required.</span>}
              </div>
              <div className="mb-3">
                <label for="confirmNewUserPassword" className="form-label">Confirm Password</label>
                <input className="form-control" type="password" id="confirmNewUserPassword"
                  placeholder="Confirm New Password"
                  name='confirmNewUserPassword'
                  value={state.confirmNewUserPassword}
                  {...register("confirmNewUserPassword", { required: true, minLength: 12, onChange: (e) => handleInputChange(e) })} />
                {errors.confirmNewUserPassword && <span style={{ color: "red" }}> Minimum 12 Characters Required..</span>}
                <br></br> {state.newUserPassword !== state.confirmNewUserPassword && <span style={{ color: 'red' }}>Password Does not match</span>}
              </div>
              <div className="mb-0 text-center d-grid">
                <button className="btn btn-primary" type="submit"><i className="mdi mdi-lock-reset"></i> Reset Password </button>
              </div>
            </form>
            <footer className="footer footer-alt">
              <p className="text-muted">Back to <a onClick={() => navigate('/login')} className="text-muted ms-1"><b>Log In</b></a></p>
            </footer>
          </div>
        </div>
      </div>
    </div>
  )
}
